import React, { useState } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";


import HR from "components/HR/HR"
import FormElement from "components/FormElement/FormElement"
import Button from "components/Button/Button"
import TableDefEvidence from "table-defs/TableDefEvidence"
import FullDataTable from "components/DataTable/FullDataTable"

import UploadDocument from "components/UploadDocument/UploadDocument";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

import {
    createEvidenceAction,
    loadEvidenceByTaskAction,
    deleteEvidenceAction,
    downloadEvidenceAction,
} from "store/actions/Actions";

import styles from "./AddEvidence.module.scss"

const EditEvidence = (props) => {
    const {
        files,
        taskId,
        CreateEvidenceReducer,
        createEvidenceAction,
        deleteEvidenceAction,
        downloadEvidenceAction,
        UserOrgSiteReducer,
    } = props;

    const [state, setState] = useState({
        "file": "",
        "name": "",
    });

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const addEvidence = () => {
        try {
            createEvidenceAction({
                "entity_type": "task",
                "entity_id": taskId,
                "file": {
                    "file": state["file"],
                    "name": state["name"],
                },
            });
            setState({
                "file": "",
                "name": "",
            });
        } catch (error) {
            console.log(error);
        }
    }

    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    const deleteEvidence = (payload) => {
        try {
            setShowConfirmModal({
                title: 'Delete evidence file',
                question: `You're about to permanently delete evidence file "${payload.filename}"! Are you sure?`,
                confirmAction: () => deleteEvidenceAction({ id: payload.id, entity_id: taskId, entity_type: 'task' }),
            });
        } catch (error) {
            console.log(error);
        }
    }

    const downloadEvidence = (payload) => {
        try {
            downloadEvidenceAction({ hash: payload.hash })
        } catch (error) {
            console.log(error);
        }
    }

    const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    return (
        <div className={`${styles["add-evidence"]} ${props.className || ""}`}>
            <p className={styles["add-evidence-heading"]}>Attach Evidence</p>

            <HR />

            {showConfirmModal && renderConfirmModal()}

            <div className={styles["add-evidence-data"]}>
                <>
                    <div className={styles["holder"]}>
                        <FormElement
                            labelText="DOCUMENTS"
                            htmlFor="documents"
                        >
                            <UploadDocument
                                state={state}
                                setState={setState}
                                formats={['jpg', 'jpeg', 'png', 'gif', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']}
                            />
                        </FormElement>

                        <Button
                            className={styles.button}
                            text="UPLOAD EVIDENCE"
                            icon={CreateEvidenceReducer.status === 'ISBUSY' ? "fad fa-spinner-third fa-spin" : "fad fa-upload"}
                            disabled={state["file"] === "" ? true : false}
                            onClick={addEvidence}
                        />
                    </div>

                    <br />
                    <br />
                </>

                <FullDataTable
                    className={styles["add-evidence-table"]}
                    rowsData={files}
                    definitions={TableDefEvidence}
                    customTableProps={(is_officer || is_super) ? { deleteEvidence, downloadEvidence } : { downloadEvidence }}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    EvidenceReducer: state.EvidenceReducer,
    CreateEvidenceReducer: state.CreateEvidenceReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    createEvidenceAction,
    deleteEvidenceAction,
    downloadEvidenceAction,
    loadEvidenceByTaskAction,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditEvidence);
